import { Box, styled } from '@mui/material';
import {
  CalendarSlotType,
  getCalendarColorScheme
} from '../../Calendar.colors';

// TODO: 1275 Remove after decision is made that we don't use colored borders in AppointmentPlanning.
export const AvailabilityEventContainer = styled(Box, {
  shouldForwardProp: (propName) => propName !== 'type'
})<{
  type: CalendarSlotType;
}>(({ theme, type }) => {
  const { stripColor } = getCalendarColorScheme(type, theme);

  return {
    height: '100%',
    margin: theme.spacing(0.25),
    marginLeft: 0,
    borderRadius: theme.spacing(0.5),
    backgroundColor: stripColor,
    border: `3px solid ${stripColor}`
  };
});
